<template>
    <DefaultHeader />
    <div :class="{ 'd-none': this.$store.state.hiddenBody }" class="container-fluid">
        <div class="row d-flex justify-content-center">
            <div v-if="badges != null && badges.length===0 && this.$refs.inputDisplay.searchInput==null" class="col-11 mb-lg-5 d-flex justify-content-center">
                <span class="text-black-50 text-center">
                    Gestion des badges de démarrage des véhicules.<br/>
                    Vous n'avez actuellement aucun badge.<br/>
                    <br/>
                    Exemple :
                </span>
            </div>
            <div v-else class="col-3 mb-lg-2 d-flex justify-content-center">
                <SearchDisplay :searchFunction="'searchWord'" @searchWord="refreshData" ref="inputDisplay"/>
            </div>
        </div>
        <div class="row d-flex justify-content-center">
            <div class="col-11 mb-3 mb-lg-5">
                <div class="card table-nowrap table-card">
                    <div class="table-responsive">
                        <table class="table mb-0 table-striped">
                            <thead class="small text-uppercase bg-body text-muted">
                                <tr>
                                    <th class="align-middle">Ref</th>
                                    <th class="align-middle">Numéro</th>
                                    <th class="align-middle">Nom</th>
                                    <th class="align-middle">Prénom</th>
                                    <th class="align-middle">
                                        Profil
                                        <router-link :to="'/badgeprofileslist/'"> 
                                            <InfoDisplay
                                            :icon="'link'"
                                            :color="'blue'"/>
                                        </router-link>
                                    </th>
                                    <th class="align-middle">Status</th>
                                    <th class="align-middle"></th>
                                </tr>
                            </thead>
                            <tbody v-if="badges != null && badges.length===0 && this.$refs.inputDisplay.searchInput==null">
                                <tr>
                                    <td class="text-black-50 fst-italic">A001</td>
                                    <td class="text-black-50 fst-italic"># E82900192H43988</td>
                                    <td class="text-black-50 fst-italic">LINCOLN</td>
                                    <td class="text-black-50 fst-italic">Abraham</td>
                                    <td class="text-black-50 fst-italic">Poids-lourds</td>
                                    <td>
                                        <InfoDisplay
                                        :icon="'check'"
                                        :color="'green'"
                                        :toolTip="'Actif'"
                                        :size="'xl'" />
                                    </td>
                                    <td class="text-end">
                                        <div class="me-4">
                                            <a data-bs-toggle="dropdown" href="#" class="btn p-1" aria-expanded="false">
                                                <font-awesome-icon :icon="['fas', 'bars']"/>
                                            </a>
                                            <div class="dropdown-menu dropdown-menu-end" style="">
                                                <a href="#!" class="dropdown-item text-black-50 fst-italic">Modifier</a>
                                                <a href="#!" class="dropdown-item text-black-50 fst-italic">Désactiver</a>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td class="text-black-50 fst-italic">A002</td>
                                    <td class="text-black-50 fst-italic"># 22193064100012H</td>
                                    <td class="text-black-50 fst-italic">JEFFERSON</td>
                                    <td class="text-black-50 fst-italic">Thomas</td>
                                    <td class="text-black-50 fst-italic">Voitures</td>
                                    <td>
                                        <InfoDisplay
                                        :icon="'cross'"
                                        :color="'red'"
                                        :toolTip="'Désactivé'"
                                        :size="'xl'" />
                                    </td>
                                    <td class="text-end">
                                        <div class="me-4">
                                            <a data-bs-toggle="dropdown" href="#" class="btn p-1" aria-expanded="false">
                                                <font-awesome-icon :icon="['fas', 'bars']"/>
                                            </a>
                                            <div class="dropdown-menu dropdown-menu-end" style="">
                                                <a href="#!" class="dropdown-item text-black-50 fst-italic">Modifier</a>
                                                <a href="#!" class="dropdown-item text-black-50 fst-italic">Activer</a>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                            <tbody v-else>
                                <TableRow v-for="badge in badges"
                                :key="badge.id"
                                :badge="badge"
                                :profiles="profiles"
                                @save="updateBadge">
                                </TableRow>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <DefaultFooter />
</template>
    
<script>
import DefaultHeader from '@/components/DefaultHeader.vue'
import DefaultFooter from '@/components/DefaultFooter.vue'
import BadgeService from '@/services/badge.service.js'
import FormatHelper from '@/helpers/format.helper.js'
import TableRow from './Sections/TableRow.vue'
import InfoDisplay from '@/components/display/InfoDisplay.vue'
import SearchDisplay from '@/components/display/SearchDisplay.vue'


export default {
    components: {
        DefaultHeader,
        DefaultFooter,
        TableRow,
        InfoDisplay,
        SearchDisplay
    },
    data() {
        return {
            badges: null,
            profiles: null
        };
    },
    mounted() {
        this.refreshData();
    },
    methods: {
        refreshData(searchInput = null) {
            BadgeService.getClientBadges(searchInput)
            .then(response => {
                this.badges = FormatHelper.badgesResponseFormat(response.data);
            })
            .catch(e => {
                console.log(e);
            });

            BadgeService.getClientBadgeProfiles()
            .then(response => {
                this.profiles = FormatHelper.badgeProfilesResponseFormat(response.data);
            })
            .catch(e => {
                console.log(e);
            });
        },
        updateBadge(data) {
            BadgeService.updateBadge(data)
            .then(() => {
                this.refreshData();
            })
            .catch(e => {
                console.log(e);
            });
        },
    }
}
</script>